import React, { useState, useMemo, useEffect } from 'react';
import cx from '@3ui/cx';

import S from './Alert.module.css';

const url = 'https://zubach.com/iphone';
const text = 'iPhone 4 in pure css! Awesome creation! (made by @Vasyl_Zubach)';
const tweet = `https://twitter.com/share?url=${url}&text=${text}`;

interface State {
  isShown: boolean;
  isResolved: boolean;
  isHidden: boolean;
}
const Alert = ({ isOn }) => {
  const initialState: State = {
    isShown: false,
    isResolved: false,
    isHidden: false
  };
  const [state, setState] = useState(initialState);
  const onCancel = useMemo(
    () => () => setState((prevState) => ({ ...prevState, isResolved: true })),
    []
  );
  const openAlert = useMemo(
    () => () => setState((prevState) => ({ ...prevState, isShown: true })),
    []
  );
  const hideAlert = useMemo(
    () => () => {
      setState((prevState) => ({ ...prevState, isHidden: true }));
    },
    []
  );

  const { isResolved, isShown, isHidden } = state;

  useEffect(() => {
    if (isResolved || !isOn) {
      return;
    }
    const timer = setTimeout(() => {
      openAlert();
    }, 2000);
    return () => clearTimeout(timer);
  }, [isOn, isResolved]);

  if (isHidden) {
    return null;
  }

  return (
    <div
      className={S.root}
      data-is-active={!isShown ? '' : (!isResolved).toString()}
      onTransitionEnd={isResolved ? hideAlert : undefined}
    >
      <div className={S.alert}>
        <div className={S.text}>
          <b className={S.b}>Simple Alert in CSS3</b> iPhone 4 in pure css!
          Awesome creation! Tweet this?
        </div>
        <div className={cx(S.button, S.btnCancel)} onClick={onCancel}>
          Cancel
        </div>
        <a
          className={cx(S.button, S.btnTweet)}
          href={tweet}
          target="_blank"
          rel="nofollow noreferrer"
        >
          Tweet
        </a>
        <br className="clear" />
      </div>
    </div>
  );
};

export default Alert;
